import { RepeatSettings } from "./lib/repeat";

// Mirrors the Sound from soundboard.go
export class Sound {
    id: string
    name: string
    datapath: string
    html_data_type: string
    size_bytes: number | undefined

    constructor(rawData: any) {
        this.id = rawData.id;
        this.name = rawData.name;
        this.datapath = rawData.datapath;
        this.html_data_type = rawData.html_data_type;
        this.size_bytes = rawData.size_bytes !== null ? rawData.size_bytes : undefined;
    }
}

type rawPlaySettings = { repeat: object | null, enabled: boolean, volume: number };
export class PlaySettings {
    repeat: RepeatSettings | null; // Null is do not repeat
    enabled: boolean;
    volume: number;

    constructor(repeat: RepeatSettings | null, enabled: boolean, volume: number) {
        this.repeat = repeat;
        this.enabled = enabled;
        this.volume = volume;
    }

    public static fromRaw(rawData: rawPlaySettings): PlaySettings {
        if (
            rawData.repeat === undefined ||
            rawData.enabled === undefined ||
            rawData.volume === undefined
        ) {
            throw new Error("Please only pass well-formed raw data to PlaySettings")
        }
        return new PlaySettings(
            rawData.repeat !== null ? RepeatSettings.fromRaw(rawData.repeat) : null,
            rawData.enabled,
            rawData.volume,
        )
    }
}

export type CardKind = string;
export const CardKinds = {
    Plain: "plain",
    Ambience: "ambience",
    Music: "music",
    Effect: "effect",
}

export class SoundCard {
    id: string;
    name: string;
    sound: Sound;
    kind: CardKind;
    playSettings: PlaySettings;

    constructor(name: string, id: string, sound: Sound, kind: CardKind, playSettings: PlaySettings) {
        this.id = id;
        this.name = name;
        this.sound = sound
        this.kind = kind;
        this.playSettings = playSettings;
    }

    public static fromRaw(name: string, id: string, rawSound: any, kind: CardKind, playSettings: rawPlaySettings): SoundCard {
        return new SoundCard(
            name,
            id,
            new Sound(rawSound),
            kind,
            PlaySettings.fromRaw(playSettings),
        )
    }

    public clone(): SoundCard {
        const clone = structuredClone(this);
        return SoundCard.fromRaw(
            clone.name,
            clone.id,
            clone.sound,
            clone.kind,
            clone.playSettings,
        );
    }

    public asKind(newKind: CardKind) {
        const oldKind = structuredClone(this.kind);
        this.kind = newKind;
        switch (newKind) {
            case CardKinds.Music:
                this.playSettings.enabled = true;

                // When we move anything to music, the repeat settings must not be kept.
                if (oldKind !== CardKinds.Music) {
                    this.playSettings.repeat = null;
                }
                break;

            case CardKinds.Effect:
                this.playSettings.volume = 100;
                this.playSettings.repeat = null;
                this.playSettings.enabled = true;
                break;

            case CardKinds.Ambience:
                this.playSettings.repeat = RepeatSettings.LOOP();
        }
    }
}
